module.exports = __webpack_public_path__ + "img/GraphQL.b724016e.png";